export default "__VITE_ASSET__D56t7viA__"